import $ from 'jquery';
import {combineElements} from "../../utilities/selectorHelpers";
import {isPresent} from "../../utilities/general";
import AddressEventBus from "./AddressEventBus";
//import { truncate } from 'fs-extra';

export default function addressValidationFactory(el, scopeForData, options={},){
  let {isAlreadyValid , currentTab} = options;
  if(!el) { // if el passed as null, then user currentTab div to asociate an AddressValidation instance instead of attaching to same address valiadtion modal div.
    el = $(currentTab);
  }

  let addressValidation = el.data('address-validation-modal');
  if(addressValidation){
    return addressValidation;
  }
  else{
    addressValidation = new AddressValidation(el, scopeForData, options);
    addressValidation.init();
    el.data('address-validation-modal', addressValidation);
    return addressValidation;
  }
}

function AddressValidation(el, scopeForData, options={}){

	const self = this;
	//const scopeForData = wizard.getscopeForData();
	self.options = options;
  let {isAlreadyValid , currentTab, disableUserEnteredAddressRadio, disableSubmitAddressBtnIfInvalidAddress} = options;
  const els = {};
	let done;
  let addressResponse = {};
  let namespace = "";
	self.init = function(){
		setElements();
    bindElements();
	};

	const validateWizardAddressURL  = scopeForData.data("address-validation-url");
  const rtlAddressValidationLevel = scopeForData.data("rtl-address-validation-level");
  const screenName = scopeForData.data("address-validation-for");
  const generalErrorMessage = scopeForData.data("general-error-message");
  const addressFoundTitleText = scopeForData.data("add-validation-add-found-title-text");
  const addressNotFoundText = scopeForData.data("add-validation-system-not-found-add-text");
  const fedexCrossBorderAdd = scopeForData.data("add-validation-cross-border-address");
  let valReqdCountries = scopeForData.data("validation-reqd-countries");

  console.log('screenName :' + screenName);

	function setElements() {
    screenSpecificFuncs[`${screenName}SetElements`]();
    setComboElement();
	}

  self.setIsAlreadyValid = function (val){
    isAlreadyValid = val;
  };

  self.getAlreadyValid = function() {
    return isAlreadyValid;
  };

  self.getAddressResponse = function() {
    return addressResponse;
  };

  self.resetAddressResponse = function() {
    addressResponse = {};
  };

  function isValidationReqdCountry() {
    //console.log(valReqdCountries);
    const cVal = els.country.val();
    let isValidCountry = false;
    $(valReqdCountries).each(function() {
        if(screenName === "asn" && this.cdmValue === cVal) {
          isValidCountry = true;
          return false;
        } else if(screenName === "order" && this.cdmMeaning === cVal) {
          isValidCountry = true;
          return false;
        }else if(screenName === "maintainRetailer" && this.cdmValue === cVal) {
          isValidCountry = true;
          return false;
        }else if(screenName === "standardPlatformFacility" && this.cdmMeaning === cVal){
          isValidCountry = true;
          return false;
        }else if(screenName === "SelfOnboardRetailer"){
          isValidCountry = true;
          return false;
        }
        else if(screenName === "AccountConfiguration"){
          isValidCountry = true;
          return false;
        }
    });
    if(!isValidCountry) {
      addressResponse = {};
      isAlreadyValid = true;
    }
    console.log("isValidationReqdCountry" +isValidCountry);
  }

  /**
    HB-14019
  */
  function isAddressValidationReqd() {
    if(isPresent(rtlAddressValidationLevel) && rtlAddressValidationLevel === "Level0") {
      isAlreadyValid = true;
      console.log("isAddressValidationReqd" +isAlreadyValid);
    }
  }

	self.determineAddressValidity = function(doneFunc) {
		done = doneFunc || (()=>{});
    //if country is not part of the validation required
    //country we don't need the validation. so first check the
    //country and proceed with validation.
    isValidationReqdCountry();
    isAddressValidationReqd();
    if(isAlreadyValid) {
      console.log('no validation needed.');
      if(screenName === 'AccountConfiguration' && document.getElementById('addLocationFlagForAddressValidation').value != 'undefined'){
        $("#addLocationFlagForAddressValidation").val("Validated");
        $("#shipToLocations").css("display","block");
        $("#shipToLocationsEdit").css("display","block");
        $("#saveLocationSection").css("dsiplay", "none");
        //document.getElementById("saveLocationSection").style.visibility = "hidden";
        document.getElementById("saveLocationSection").style.display = "none";
        document.getElementById("completeFieldsMsg").style.visibility = "hidden";
    
        $("#confirmationBoxToSaveAccountAddress").modal("hide");
      }

      done(true);
      if(screenName === "SelfOnboardRetailer"){
        $("#confirmationBox").modal("show");
      }
      if(screenName === 'AccountConfiguration' && currentTab === ".so-accounts-tab" ){
        $("#confirmationBoxToSaveAccountAddress").modal("show");
      }
    } else {
      console.log('validation needed.');
      validateWizardAddress({url: validateWizardAddressURL, success: validateAddressSuccess, error: validateAddressError});
    
    }
	};

	function validateWizardAddress({url, success, error}) {
    showModal();
    showLoadingModal();
    
    const countryVal = els.country.val();
    let stateVal = "";
    let data = {};
    
    if(countryVal == "1" || countryVal == "2"
          || countryVal == "US" || countryVal == "CA") {
      stateVal = els.state.val();
    } else {
      stateVal = els.stateText.val();
    }
    if(screenName === "order" || screenName === "maintainRetailer"
                  || screenName === "standardPlatformFacility" || screenName === "SelfOnboardRetailer" || screenName ==='AccountConfiguration') {
      data = {
          address1: els.address1.val(),
          address2: els.address2.val(),
          city: els.city.val(),
          zipcode: els.zipcode.val(),
          state: stateVal,
          country: els.country.val(),
          callType: "addressValidation"
        };
    } else {
      data = {
        [`${namespace}address1`]: els.address1.val(),
        [`${namespace}address2`]: els.address2.val(),
        [`${namespace}city`]: els.city.val(),
        [`${namespace}zipcode`]: els.zipcode.val(),
        [`${namespace}state`]: stateVal,
        [`${namespace}country`]: els.country.val(),
        [`${namespace}callType`]: "addressValidation"
      };
    }
		$.ajax({
      data: data,
		  url: url,
		  dataType:"JSON",
		  type: 'POST',
		  success: success,
		  error: error
		});
	}

	function validateAddressSuccess(data){
    
   
    addressResponse = data;
		if(data.response == "success" && !data.isAddFixed) {
      if(data.resolvedFlag == 'true') {
        addressFoundModal(data);
        
      } else {
        addressNotFoundModal(data);
      }

      
		} else if(data.response == "crossborder" && !data.isAddFixed) {
      crossBorderAddress(data);

    } else {
      isAlreadyValid = true;
      hideModal();
      if(screenName === 'AccountConfiguration' && document.getElementById('addLocationFlagForAddressValidation').value != 'undefined'){
        $("#addLocationFlagForAddressValidation").val("Validated");
        $("#shipToLocations").css("display","block");
        $("#shipToLocationsEdit").css("display","block");
        $("#saveLocationSection").css("dsiplay", "none");
        $("#confirmationBoxToSaveAccountAddress").modal("hide");
        //document.getElementById("saveLocationSection").style.visibility = "hidden";
        document.getElementById("saveLocationSection").style.display = "none";
        document.getElementById("completeFieldsMsg").style.visibility = "hidden";
      }
      done(true);
      if(screenName === "SelfOnboardRetailer"){
        $("#confirmationBox").modal("show");
      }
      if(screenName === 'AccountConfiguration' && currentTab === ".so-accounts-tab" ){
        $("#confirmationBoxToSaveAccountAddress").modal("show");
      }
      
    }
	}

	function validateAddressError() {
    hideModal();
    if(screenName === "maintainRetailer") { // user should not be able to navigate further, orther screens is ok
      done(false);
    } else {
      done(true);
    }
    alert(generalErrorMessage);
	}

  function empty(str) {
	    if (typeof str == 'undefined' || !str || str.length === 0 || str === "" ||
	    		!/[^\s]/.test(str) || /^\s*$/.test(str) || str.replace(/\s/g,"") === "") {
	        return true;
      } else {
	        return false;
	    }
	}

  function addressFoundModal(data) {
    let userAddHtml = data.address1;
    if(!empty(data.address2)) {
      userAddHtml += ","+data.address2+","+data.city+","+data.state+","+data.zip;
    } else {
      userAddHtml += ","+data.city+","+data.state+","+data.zip;
    }

    $("#add-validation-user-entered-add").html(userAddHtml);

    let sysAddHtml = data.stdAddress1;
    if(!empty(data.stdAddress2)) {
      sysAddHtml += ","+data.stdAddress2+","+data.stdCity+(data.stdState == null ?"":","+data.stdState)+(data.stdZip == null ? "" : ","+data.stdZip );
    } else {
      sysAddHtml += ","+data.stdCity+(data.stdState == null ?"":","+data.stdState)+(data.stdZip == null ? "" : ","+data.stdZip );
    }

    $("#add-validation-system-found-add").html(sysAddHtml);
    showAddressFoundModal();
	}

	function addressNotFoundModal(data) {

    let userAddHtml = data.address1;
    if(!empty(data.address2)) {
      userAddHtml += ","+data.address2+","+data.city+","+data.state+","+data.zip;
    } else {
      userAddHtml += ","+data.city+","+data.state+","+data.zip;
    }

    $("#add-validation-user-entered-add").html(userAddHtml);
		showAddressNotFoundModal();
	}

  function crossBorderAddress(data) {

    let userAddHtml = data.address1;
    if(!empty(data.address2)) {
      userAddHtml += ","+data.address2+","+data.city+","+data.state+","+data.zip;
    } else {
      userAddHtml += ","+data.city+","+data.state+","+data.zip;
    }
    $("#add-validation-user-entered-add").html(userAddHtml);
    showCrossBorderAddressModal();
  }

  $('.mod-address-btn').click(function(e){
     $(".crossborder-address-section").hide();
     if(screenName === 'AccountConfiguration' && document.getElementById('addLocationFlagForAddressValidation').value != 'undefined'){
    $("#shipToLocations").css("display","none");
    $("#saveLocationSection").css("dsiplay", "block");
    $("#shipToLocationsEdit").css("display","block");
    }
    e.preventDefault();
    isAlreadyValid = false;
    hideModal();
    done(false);
  });

  $('.use-selected-address-btn').click(function(e){
    e.preventDefault();
      if(screenName === 'AccountConfiguration' && document.getElementById('addLocationFlagForAddressValidation').value != 'undefined'){
        $("#addLocationFlagForAddressValidation").val("Validated");
        $("#shipToLocations").css("display","block");
        $("#shipToLocationsEdit").css("display","block"); 
        $("#saveLocationSection").css("dsiplay", "none");
        $("#confirmationBoxToSaveAccountAddress").modal("hide");
        document.getElementById("noneAddedMsg").style.visibility = "hidden";
        //document.getElementById("saveLocationSection").style.visibility = "hidden";
        document.getElementById("saveLocationSection").style.display = "none";
        document.getElementById("completeFieldsMsg").style.visibility = "hidden";
      }
    // in some case like in maintain retailer, the button may be disabled and we dont want to process the event
    let useThisAddressBtnDisabled = $('.use-selected-address-btn').is('[disabled=disabled]');
    // sometimes AddressValidation object is created but doneFunc is never created from determineAddressValidaty
    // if that happens, addressResponse is empty and the done() function at end of this method fails.
    if($.isEmptyObject(addressResponse) || useThisAddressBtnDisabled) {
      return;
    }
    const useStdAddress = $('[name=radioAddressChoice]:checked').val();

    if(useStdAddress === "1") {
      addressResponse.useStdAddress = useStdAddress;

      const countryVal = addressResponse.stdCountry;
      els.address1.val(addressResponse.stdAddress1);
      els.address2.val(addressResponse.stdAddress2);
      els.city.val(addressResponse.stdCity);
      els.zipcode.val(addressResponse.stdZip);
      els.country.val(countryVal);
      if(countryVal == "1" || countryVal == "2"
          || countryVal == "US" || countryVal == "CA") {
        els.state.val(addressResponse.stdState);
      } else {
        els.stateText.val(addressResponse.stdState);
      }
      if(screenName === "maintainRetailer") { // currently only required for Manage retailer screens
        els.commercialAddressFlag.val(addressResponse.isCommercial);
      }

      // make sure to notify event bus of possible
      // silent input changes that were performed above...
      // This is terrible because the correct archetecture
      // was not followed here.
      AddressEventBus.emitChange();

    }
    else{
      addressResponse.useStdAddress = "0";
    }
      

    isAlreadyValid = true;
    hideModal();
    done(true);
    if(screenName === "SelfOnboardRetailer"){
      $("#confirmationBox").modal("show");
    }
    if(screenName === 'AccountConfiguration' && currentTab === ".so-accounts-tab" ){
      $("#confirmationBoxToSaveAccountAddress").modal("show");
    }
  });

  function showLoadingModal(){
    $("#address-found-or-not-text").html("");
    $(".address-select-choices-outer").hide();
    $(".address-validation-loading-outer").show();
		$(".mod-address-btn").hide();
    $(".use-selected-address-btn").hide();
    $(".validate-address-btn").hide();
  }

  function showModal() {
    $("#add-validation-model").modal("show");
  }

  function hideModal() {
    $("#add-validation-model").modal("hide");
  }

  function showAddressFoundModal() {
    $("#address-found-or-not-text").html(addressFoundTitleText);
    if($("#radio-entered-address").hasClass("q-radio-hide")) {
      $("#radio-entered-address").removeClass("q-radio-hide");
    }
    $("#radio-entered-address").prop("checked",false);
    $("#radio-found-address").prop("checked", true);
    $(".address-select-choices-outer").show();
    $(".found-address-item").show();
    $(".modify-address-section").hide();
    $(".no-address-found-section").hide();
    $(".address-validation-loading-outer").hide();
		$(".mod-address-btn").show();
    $(".use-selected-address-btn").show();
    $(".use-selected-address-btn").attr("disabled", false); // if this options is passed
    $(".validate-address-btn").hide();
  }

  function showAddressNotFoundModal() {
    $("#address-found-or-not-text").html(addressNotFoundText);
    if($("#radio-entered-address").hasClass("q-radio-hide")) {
      $("#radio-entered-address").removeClass("q-radio-hide");
    }
    $("#radio-entered-address").prop("checked",true);
    $("#radio-found-address").prop("checked", false);
    $(".address-select-choices-outer").show();
    $(".found-address-item").hide();
    $(".modify-address-section").hide();
    $(".no-address-found-section").show();
    $(".address-validation-loading-outer").hide();
		$(".mod-address-btn").show();
    $(".use-selected-address-btn").show();
    $(".validate-address-btn").hide();
  }

  function showCrossBorderAddressModal() {
    $("#address-found-or-not-text").html(fedexCrossBorderAdd);
    if($("#radio-entered-address").hasClass("q-radio-hide")) {
      $("#radio-entered-address").removeClass("q-radio-hide");
    }
    $('#radio-entered-address').attr("disabled", disableUserEnteredAddressRadio); // If this option is passed
    $("#radio-found-address").removeAttr('checked');
    $(".address-select-choices-outer").hide();
    $(".found-address-item").hide();
    $(".modify-address-section").hide();
    $(".no-address-found-section").show();
    $(".address-validation-loading-outer").hide();
    $(".mod-address-btn").show();
    $(".use-selected-address-btn").attr("disabled", false); // if this options is passed
    $(".use-selected-address-btn").hide();
    $(".validate-address-btn").hide();
    $(".crossborder-address-section").show();
  }

  const screenSpecificFuncs = {
    orderSetElements: function(){
      els.address1 = scopeForData.find("#destination-tab-address1");
      els.address2 = scopeForData.find("#destination-tab-address2");
      els.city = scopeForData.find("#destination-tab-city");
      els.zipcode= scopeForData.find("#destination-tab-zipCode");
      els.state = scopeForData.find("#destination-tab-state");
      els.stateText = scopeForData.find("#destination-tab-stateText");
      els.country = scopeForData.find("#destination-tab-country");
    },

    asnSetElements: function(){
      namespace = scopeForData.data('namespace');

      els.address1 = scopeForData.find("#"+namespace+"cadAddress1");
      els.address2 = scopeForData.find("#"+namespace+"cadAddress2");
      els.city = scopeForData.find("#"+namespace+"cadCity");
      els.zipcode= scopeForData.find("#"+namespace+"cadZipcode");
      els.state = scopeForData.find("#"+namespace+"states");
      els.stateText = scopeForData.find("#"+namespace+"cadStateText");
      els.country = scopeForData.find("#"+namespace+"cadCountry");
    },
    maintainRetailerSetElements: function(){
      els.address1 = $(currentTab).find(".ret-address1");
      els.address2 = $(currentTab).find(".ret-address2");
      els.city = $(currentTab).find(".ret-city");
      els.zipcode= $(currentTab).find(".ret-zip-code");
      els.state = $(currentTab).find(".ret-state");
      els.stateText = $(currentTab).find(".ret-state-text");
      els.country = $(currentTab).find(".ret-country");
      els.commercialAddressFlag = $(currentTab).find(".commercial-addr-flag");
    },
    standardPlatformFacilitySetElements: function(){
      els.address1 = scopeForData.find("#fac-address-tab-address1");
      els.address2 = scopeForData.find("#fac-address-tab-address2");
      els.city = scopeForData.find("#fac-address-tab-city");
      els.zipcode= scopeForData.find("#fac-address-tab-zip");
      els.state = scopeForData.find("#fac-address-tab-state");
      els.stateText = scopeForData.find("#fac-address-tab-stateText");
      els.country = scopeForData.find("#fac-address-tab-country");
    },
    SelfOnboardRetailerSetElements: function(){
      els.address1 = scopeForData.find(".ret-address1");
      els.address2 = scopeForData.find(".ret-address2");
      els.city = scopeForData.find(".ret-city");
      els.zipcode= scopeForData.find(".ret-zip-code");
      els.state = scopeForData.find(".ret-state");
      els.stateText = scopeForData.find(".ret-state-text");
      els.country = scopeForData.find(".ret-country");
     // els.commercialAddressFlag = scopeForData.find(".commercial-addr-flag");
    },
    AccountConfigurationSetElements: function(){
      console.log("currentTab is" +currentTab);

      els.address1 = scopeForData.find(".ret-address1");
      els.address2 = scopeForData.find(".ret-address2");
      els.city = scopeForData.find(".ret-city");
      els.zipcode= scopeForData.find(".ret-zip-code");
      els.state = scopeForData.find(".ret-state");
      els.stateText = scopeForData.find(".ret-state-text");
      els.country = scopeForData.find(".acc-country");
      
      if(screenName === 'AccountConfiguration' && currentTab === ".so-locations-tab" && document.getElementById('addLocationFlagForAddressValidation').value != 'undefined'){
        els.address1 = scopeForData.find(".fac-address1");
        els.address2 = scopeForData.find(".fac-address2");
        els.city = scopeForData.find(".fac-city");
        els.zipcode= scopeForData.find(".fac-zip-code");
        els.state = scopeForData.find(".fac-state");
        els.stateText = scopeForData.find(".fac-state-text");
        els.country = scopeForData.find(".fac-country");
      } 
    
  }

    
  };

  function setComboElement(){
    els.allInputs = combineElements([
      els.address1,
      els.address2,
      els.city,
      els.zipcode,
      els.state,
      els.stateText,
      els.country
    ]);
  }

  // bind all elements in els
  // on change of any of these elements, mark isAlreadyValid false
  // on next/jump-to-future-tab (determineAddressValidity)
  // we need to use isAlreadyValid to determine if crap should happend.

  function bindElements() {
    els.address1.on("change", handleAddressInputChange);
    els.address2.on("change", handleAddressInputChange);
    els.city.on("change", handleAddressInputChange);
    els.zipcode.on("change", handleAddressInputChange);
    els.state.on("change", handleAddressInputChange);
    els.stateText.on("change", handleAddressInputChange);
    els.country.on("change", handleAddressInputChange);
  }

  function handleAddressInputChange(e){
    e.preventDefault();
    isAlreadyValid = false;
    console.log('handleAddressInputChange');
  }

}



// WEBPACK FOOTER //
// ./src/pages/common/AddressValidation.js